import type { Ref } from 'vue';

import {
	PropertyTypeEnum,
	propertyTypesTranslations
} from '~/core/entities/CRMEnums';
import { useShortsFeedStore } from '~/store/shortsFeedStore';
import { computed, isRef } from 'vue';

export function useHighlightedPropertyTypes(
	selectedPropertyTypes: Ref<PropertyTypeEnum[]> | PropertyTypeEnum[]
) {
	const shortsFeedStore = useShortsFeedStore();

	const highlightedPropertyTypesFromShorts = computed(() => {
		const videos = shortsFeedStore.videos || [];
		const counts = new Map<PropertyTypeEnum, number>();
		videos.forEach(({ property }) => {
			const id = property?.propertyType?.identifier;
			if (id)
				counts.set(
					id as PropertyTypeEnum,
					(counts.get(id as PropertyTypeEnum) ?? 0) + 1
				);
		});

		if (counts.size < 3) return [];

		const excludedTypes = isRef(selectedPropertyTypes)
			? selectedPropertyTypes.value
			: selectedPropertyTypes;

		return [...counts.entries()]
			.sort((a, b) => b[1] - a[1])
			.slice(0, 5)
			.map(([value]) => ({
				value,
				label: propertyTypesTranslations[value] ?? value
			}))
			.filter(item => !excludedTypes.includes(item.value));
	});

	return { highlightedPropertyTypesFromShorts };
}
